"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {value: true});
exports.FormattedDate = void 0;
var _react = _interopRequireDefault(require("react"));
var _formattedDate = require("./formatted-date.utils");
var FormattedDate = function FormattedDate(_ref) {
	var date = _ref.date, className = _ref.className;
	if ((0, _formattedDate.isToday)(date)) {
		return/*#__PURE__*/_react.default.createElement("span", {className: className}, "\u0421\u0435\u0433\u043E\u0434\u043D\u044F, ", (0, _formattedDate.getFormattedTime)(date));
	}
	if ((0, _formattedDate.isYesterday)(date)) {
		return/*#__PURE__*/_react.default.createElement("span", {className: className}, "\u0412\u0447\u0435\u0440\u0430, ", (0, _formattedDate.getFormattedTime)(date));
	}
	return/*#__PURE__*/_react.default.createElement("span", {className: className}, (0, _formattedDate.getFormattedDate)(date));
};
exports.FormattedDate = FormattedDate;
FormattedDate.displayName = "FormattedDate";